module.exports = __webpack_public_path__ + "img/guia-estudio-k2.abac4ef2.png";